<template>
  <CBreadcrumb class="d-md-down-none me-auto mb-0">
    <CBreadcrumbItem
      v-for="item in breadcrumbs"
      :key="item"
      :href="item.active ? '' : item.path"
      :active="item.active"
    >
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>
</template>

<script>
import { onMounted, ref } from 'vue'
import routerSkiptraze from '@/skiptraze/router'

export default {
  name: 'SkiptrazeBreadcrumb',

  setup() {
    const breadcrumbs = ref()

    const getBreadcrumbs = () => {
      return routerSkiptraze.currentRoute.value.matched
        .filter((route) => {
          return route.name && route.name !== ''
        })
        .map((route) => {
          return {
            active: route.path === routerSkiptraze.currentRoute.value.fullPath,
            name: route.name,
            path: `${routerSkiptraze.options.history.base}${route.path}`,
          }
        })
    }

    routerSkiptraze.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
}
</script>
